<template>
	<div class="setting-page page-padding-top">
		<top-bar :title="i18n.t('setting.title')"  @back="back"></top-bar>


		<div class="setting-line flex-center-between">
			<div>
				<div>{{i18n.t('setting.label1')}}</div>
			</div>
			<div>
				<van-switch v-model="checked1" active-color="#000" @change="changeSwitch(1)" inactive-color="#E8EAED" ></van-switch>
			</div>
		</div>

		<div class="setting-line flex-center-between">
			<div>
				{{i18n.t('setting.label2')}}
			</div>
			<div>
				<van-switch v-model="checked2" active-color="#000" @change="changeSwitch(2)" inactive-color="#E8EAED"></van-switch>
			</div>
		</div>

		<div class="setting-line flex-center-between">
			<div>
				{{i18n.t('setting.label3')}}
			</div>
			<div>
				<van-switch v-model="checked3" active-color="#000" @change="changeSwitch(3)" inactive-color="#E8EAED"></van-switch>
			</div>
		</div>

		<div class="setting-line flex-center-between">
			<div>
				{{i18n.t('setting.label4')}}
			</div>
			<div>
				<van-switch v-model="checked4" active-color="#000" @change="changeSwitch(4)" inactive-color="#E8EAED"></van-switch>
			</div>
		</div>

		<div class="setting-line flex-center-between">
			<div>
				{{i18n.t('setting.label5')}}
			</div>
			<div>
				<van-switch v-model="checked5" active-color="#000" @change="changeSwitch(5)" inactive-color="#E8EAED"></van-switch>
			</div>
		</div>

		<div class="setting-line flex-center-between">
			<div>
				{{i18n.t('setting.label6')}}
			</div>
			<div>
				<van-switch v-model="checked6" active-color="#000" @change="changeSwitch(6)" inactive-color="#E8EAED"></van-switch>
			</div>
		</div>
	</div>
</template>
<script>
import { Switch } from 'vant'
import { tradeSetting, updateTradeSetting } from '@/api/trade'
import { userInfo } from '@/api/user'
import Vue from 'vue'
import topBar from '@/components/topBar'
Vue.use(Switch)
export default {
	components: {
		topBar
	},
  data() {
		return {
			backUrl: require('../../assets/imgs/icon-back.png'),
			checked1: false,
			checked2: false,
			checked3: false,
			checked4: false,
			checked5: false,
			checked6: false,
		}
	},
	mounted() {
		this.initConfirm()
	},
	methods: {
		back() {
			this.$router.go(-1)
		},
		initConfirm() {
			tradeSetting().then(res => {
				let data = res.data.Items[0] || {}
				this.checked1 = data.OptionOrderConfirm == 1 ? true : false
				this.checked2 = data.FutureOrderConfirm == 1 ? true : false
				this.checked3 = data.FollowOrderConfirm == 1 ? true : false
				this.checked4 = data.SpotOrderConfirm == 1 ? true : false
				this.checked5 = data.FinanceOrderConfirm == 1 ? true : false
				this.checked6 = data.SimulationOrderConfirm == 1 ? true : false
			})
		},
		changeSwitch() {
			let form = new FormData()
			form.append('OptionOrderConfirm', this.checked1 ? 1 : 2)
			form.append('FutureOrderConfirm', this.checked2 ? 1 : 2)
			form.append('FollowOrderConfirm', this.checked3 ? 1 : 2)
			form.append('SpotOrderConfirm', this.checked4 ? 1 : 2)
			form.append('FinanceOrderConfirm', this.checked5 ? 1 : 2)
			form.append('SimulationOrderConfirm', this.checked6 ? 1 : 2)

			updateTradeSetting(form).then(res => {
				if (res.code == 0) {
					
				} else {
					this.$toast.fail(res.msg)
				}
			})
		},
		submit() {
			let form = new FormData()
			form.append('OrderConfirm', this.checked1 ? 1 : 2)
			form.append('CancelConfirm', this.checked2 ? 1 : 2)
			confirmSetting(form).then(res => {
				if (res.code == 0) {
					this.$store.state.successMsg = this.i18n.t('common.success')
					this.$emit('change')
				} else {
					this.$store.state.errorMsg = res.msg
				}
			})
		}
	}
}
</script>